import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IAnalytics, IDateRange } from '../models/models'

export class SessionsPerUserApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/AnalyticsReporting/sessionsPerUser',
      requesterInfo,
    })
  }

  public async sessionsPerUser(request: IDateRange): Promise<IAnalytics[]> {
    return await this.postAsync<any[]>(request)
  }
}
